(() => {
  const setup = () => {
    const dialog = document.querySelector('.suria-lightbox');
    const links = [...document.querySelectorAll('.suria-gallery-content a[href]')].filter(a => a.querySelector('img') && /cdn\.shopify\.com|\/cdn\/shop\//.test(a.href));
    if (!dialog || !links.length || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const image = dialog.querySelector('.suria-lightbox-image');
    const label = dialog.querySelector('.suria-lightbox-label');
    const count = dialog.querySelector('.suria-lightbox-count');
    let index = 0;
    let opener;
    const render = next => {
      index = (next + links.length) % links.length;
      const source = links[index].querySelector('img');
      image.src = links[index].href;
      image.alt = source.alt;
      label.textContent = source.alt;
      count.textContent = `${index + 1} / ${links.length}`;
    };
    links.forEach((a, n) => a.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      opener = a;
      render(n);
      dialog.showModal();
    }));
    dialog.querySelector('.suria-lightbox-close').addEventListener('click', () => dialog.close());
    dialog.querySelector('.suria-lightbox-prev').addEventListener('click', () => render(index - 1));
    dialog.querySelector('.suria-lightbox-next').addEventListener('click', () => render(index + 1));
    dialog.addEventListener('close', () => opener?.focus());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); render(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); render(index - 1); }
    });
    let start;
    image.addEventListener('touchstart', event => { start = event.changedTouches[0].clientX; }, {passive:true});
    image.addEventListener('touchend', event => {
      if (start === undefined) return;
      const delta = event.changedTouches[0].clientX - start;
      if (Math.abs(delta) > 55) render(index + (delta < 0 ? 1 : -1));
      start = undefined;
    }, {passive:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
